import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { PasswordInput } from "../components/PasswordInput";
import { Label } from "../components/ui/label";
import { AuthShell } from "./Login";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Le password non coincidono."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata con successo");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="rounded-2xl border border-slate-200 bg-white p-8">
        <h1 className="font-heading text-2xl font-800 text-slate-900">Nuova password</h1>
        <p className="mt-1 text-sm text-slate-500">Imposta una nuova password per il tuo account.</p>
        {!token ? (
          <p className="mt-6 rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">
            Token mancante o non valido. Richiedi un nuovo link di recupero.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="pwd">Nuova password</Label>
              <PasswordInput id="pwd" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5" data-testid="reset-password-input" autoComplete="new-password" />
            </div>
            <div>
              <Label htmlFor="confirm">Conferma password</Label>
              <PasswordInput id="confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" data-testid="reset-confirm-input" autoComplete="new-password" />
            </div>
            {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full rounded-full bg-blue-700 hover:bg-blue-800" data-testid="reset-submit-btn">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reimposta password"}
            </Button>
          </form>
        )}
        <p className="mt-6 text-center text-sm text-slate-500">
          <Link to="/login" className="font-600 text-blue-700 hover:underline">Torna all'accesso</Link>
        </p>
      </div>
    </AuthShell>
  );
}
